import { getEntityType } from '@/utils';
import { convertTimeWithTimezone } from '../../../utils/time';

export const booleanValueToText = (value?: boolean) =>
  typeof value === 'boolean' ? (value ? 'Yes' : 'No') : 'N/A';
export const currentAndMaxValuesToText = (current?: number, max?: number) =>
  typeof current === 'number' && typeof max === 'number'
    ? `${current}/${max}`
    : 'N/A';
export const dateValueToText = (value?: string | number) =>
  value ? convertTimeWithTimezone(value, undefined, 'MM/DD/YYYY') : 'N/A';
export const entityTypeValueToText = (value?: string) =>
  getEntityType(value, 'N/A');
export const numberValueToText = (value?: number) =>
  typeof value === 'number' ? value : 'N/A';
export const stringValueToText = (value?: string) => value || 'N/A';
export const roleEnumToLabel = (str: string) => {
  const [, second = ''] = str.split('_');
  return second.charAt(0).toUpperCase() + second.slice(1).toLowerCase();
};

export const splitEmail = (str?: string): string[] => {
  if (typeof str !== 'string' || !str) {
    return [];
  }

  return (
    str
      .split(',')
      .map((email) => email.trim())
      .filter(Boolean) || []
  );
};

export const toggleRole = (
  roles: string[],
  targetRole: string,
  checked: boolean
) => {
  const otherRoles = roles.filter((r) => r !== targetRole);
  return checked ? [...otherRoles, targetRole] : otherRoles;
};
